import React from "react";
import { Modal } from "react-bootstrap";

export function HeaderTemplate({ title }) {
  return <Modal.Title dangerouslySetInnerHTML={{ __html: title }} />;
}
